import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'reactstrap'
import ResourceProperty from '../../../../common/resource/ResourceProperty'
import IsActive from '../../../../common/cells/IsActive'
import Table from '../../../../common/Table'
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants'
import { LOCATION_PATH, ROUTE_PATH } from '../../../../../config/paths'
import { tzNormalizeDate } from '../../../../../utils/date'
import { DATE_TIME_FORMAT } from '../../../../../config/locale'
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource'

const BoardingGroupBasicInformationResource = ({
  id,
  name,
  active,
  boardingGroupLocations,
  createDate,
  user,
  route
}) => (
  <>
    <Row>
      <Col md={6}>
        <ResourceProperty label="ID:">{id}</ResourceProperty>
        <ResourceProperty label="Nombre:">{name}</ResourceProperty>
        <ResourceProperty label="Estado:">
          <IsActive value={active} />
        </ResourceProperty>
        <ResourceProperty label="Ruta:">
          <LinkToModuleResource
            text={route.name}
            href={`${ROUTE_PATH}/${route.id}`}
            isExternalPath
          />
        </ResourceProperty>
      </Col>
      <Col>
        <ResourceProperty label="Fecha de Creación:">{
          tzNormalizeDate({ date: createDate, format: DATE_TIME_FORMAT })}</ResourceProperty>
        <ResourceProperty label="Creado por:">
          {user.customer.firstName} {user.customer.lastName} - {user.username}
        </ResourceProperty>
      </Col>
    </Row>
    <Table
      title="Ubicaciones del Grupo de Embarque"
      columns={[
        { Header: 'ID', accessor: 'location.id', className: 'text-center' },
        { Header: 'Nombre', accessor: 'location.name', className: 'text-center' },
      ]}
      data={boardingGroupLocations}
      manual={false}
      defaultPageSize={DEFAULT_PAGE_SIZE}
      filterable
      modelPath={LOCATION_PATH}
      openPathInNewTab
      navigateToModelOnRowClick
      modelId="locationId"
    />
  </>
)

export default BoardingGroupBasicInformationResource

BoardingGroupBasicInformationResource.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  boardingGroupLocations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    locationId: PropTypes.string.isRequired,
    locationName: PropTypes.string.isRequired,
    boardingGroupId: PropTypes.string.isRequired,
  })).isRequired,
  createDate: PropTypes.string.isRequired,
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    customer: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  route: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired
}
